import { useState } from 'react';
import { toast } from 'react-toastify';
import useApi from '../useApis';
const usePackage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [packageSubscriptionList, setPackageSubscriptionList] = useState(null);
  const api = useApi();
  const getAllPackages = async (params, onCancel) => {
    const response = await api?.getALLPackages(params);
    if (response?.data?.headers?.code === 200) {
      setPackages(response?.data?.body?.packages?.row);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
  };

  const addSubscription = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.addSubscription(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Package subscribed successfully');
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };
  const deleteSmsSubscription = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.deleteSubscription(params);
    if (response?.data?.headers?.code === 200) {

      addSubscription({
        pageNumber: 1,
        pageSize: 10,
        totalRowsCount: 0,
        sortField: '',
        sortDirection: '',
        search: '',
        filter: null
      });
      toast.success('Request cancel successfully');
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };

  const addMergeSubscription = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.addMergeSubscription(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Package subscribed successfully');
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };
  const getPackageSubscription = async (params, onCancel) => {
    const { filter, ...rest } = params;
    const response = await api?.getPackageSubscription(rest, filter);
    if (response?.data?.headers?.code === 200) {
      setPackageSubscriptionList(response?.data?.body);

      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
  };

  return {
    loading,
    packages,
    getAllPackages,
    addSubscription,
    addMergeSubscription,

    deleteSmsSubscription,
    getPackageSubscription,
    packageSubscriptionList
  };
};

export default usePackage;
